
import React, { useEffect } from "react";
import HomeCarousel from "../../Components/HomeCarousel";
import MainCategory from "../../Components/MainCategories/MainCategories";
import NearestShop from "../../Components/NearestShop/NearestShop";
import SubcategoryWiseProduct from "../../Components/SubcategoryWiseProduct/SubcategoryWiseProduct";
import Offers from "../../Components/Offers/Offers";
import { useDispatch } from "react-redux";
import { Searched_Type } from "../../Redux/Search";

const Home: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(Searched_Type("Products"));
  }, []);

  return (
    <>
      <HomeCarousel />
      <MainCategory />
      <NearestShop />
      <Offers />
      <SubcategoryWiseProduct />
    </>
  );
};


export default Home;
